import React from 'react';
import { TextField } from '@mui/material';

const CustomTextField = ({
  margin,
  name,
  label,
  type,
  id,
  autoComplete,
  value,
  onChange,
  disabled,
  required,
  handleKeyDown,
  autoFocus,
}) => {
  const handleChange = (event) => {
    onChange(event.target.value);
  };
  return (
    <TextField
      margin={margin}
      required={required}
      fullWidth
      name={name}
      disabled={disabled}
      variant="outlined"
      label={label}
      value={value || ''}
      type={type}
      id={id}
      onChange={handleChange}
      autoComplete={autoComplete}
      onKeyDown={handleKeyDown}
      autoFocus={autoFocus}
    />
  );
};

export default CustomTextField;
